import { FontAwesome } from '@expo/vector-icons';
import React, { useEffect, useState } from 'react';
import {
  View, StyleSheet, Text, TouchableOpacity,
} from 'react-native';
import { useSelector } from 'react-redux';
import Colors from '../constants/Colors';
import Link from './Link';
import { AppScreen } from '../navigation/LinkingConfiguration';

const ExpandableItemComponent = ({
  item, initialState, navObj, isDev, collapsed, enabledFeatures,
}) => {
  const smartGuardRoute: boolean = useSelector((state:
    { mapScreen: { smartGuardTour: boolean } }) => state.mapScreen.smartGuardTour);
  const [layoutHeight, setLayoutHeight] = useState<number>(undefined);
  const [selectedScreen,
    setSelectedScreen] = useState<string>(initialState.routeNames[initialState.index]);

  useEffect(() => {
    setSelectedScreen(initialState.routeNames[initialState.index]);
  }, [initialState]);

  return <View>
    <TouchableOpacity
      activeOpacity={0.8}
      onPress={
        item.subcategory.length > 0
          ? () => setLayoutHeight(layoutHeight === 0 ? undefined : 0)
          : () => navObj.navigate(item.category_name)
      }
      style={styles.header}
      testID={item.testID}
    >
      <Text style={styles.headerText}>{item.category_name}</Text>
      {item.subcategory.length > 0 && item.category_name !== '' && (
        <FontAwesome
          size={30}
          style={{ marginBottom: -3, color: 'white' }}
          name={item.isExpanded ? 'angle-down' : 'angle-up'}
        />
      )}
    </TouchableOpacity>
    <View
      style={{
        height: item.category_name ? layoutHeight : undefined,
        overflow: 'hidden',
      }}
    >
      {item.subcategory.map((itemSub: any, key: string) => {
        if (itemSub.featureFlag
          && !enabledFeatures[itemSub.featureFlag]) return null;
        if (!isDev // if feature enabled skip next check
          && (itemSub.beta || itemSub.dev) && !enabledFeatures[itemSub.featureFlag]) return null;
        let isSelected: boolean = itemSub.val === selectedScreen;
        if (isSelected && itemSub.val === AppScreen.MAP) {
          isSelected = itemSub.route ? smartGuardRoute : !smartGuardRoute;
        }

        return <Link key={`link_${key}`}>
          <TouchableOpacity
            style={styles.content}
            onPress={() => {
              if (itemSub.route) navObj.navigate(itemSub.val, { route: itemSub.route });
              else navObj.navigate(itemSub.val);
              setSelectedScreen(itemSub.val);
            }}
            testID={itemSub.testID}
          >
            <View style={{ flexDirection: 'row' }}>
              {(itemSub.indented && !collapsed) && <View style={styles.indent} />}
              <View style={[styles.menuItem, isSelected && styles.selectedMenuItem]}>
                {isSelected ? itemSub.selectedIcon : itemSub.icon}
                {!collapsed && <Text style={[styles.text, isSelected && styles.selectedText]}>
                  {itemSub.title ?? itemSub.val}
                </Text>}
                {itemSub.beta && <Text style={styles.betaText}>{collapsed ? 'B' : 'BETA'}</Text>}
              </View>
            </View>
            <View style={styles.separator} />
          </TouchableOpacity>
        </Link>;
      })}
    </View>
  </View>;
};

export default ExpandableItemComponent;

const styles = StyleSheet.create({
  menuItem: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    borderRadius: 8,
    marginHorizontal: 12,
    paddingLeft: 16,
    paddingVertical: 8,
    marginVertical: 4,
  },
  selectedMenuItem: {
    backgroundColor: Colors.light.hereworksBlue500,
  },
  header: {
    paddingVertical: 8,
    color: Colors.light.hereworksPrimaryGrey,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  content: {
    flex: 2,
  },
  separator: {
    height: 0.5,
    width: '95%',
    marginLeft: 16,
    marginRight: 16,
  },
  headerText: {
    fontSize: 12,
    paddingLeft: 24,
    color: Colors.light.hereworksPrimaryGrey800,
    fontFamily: 'Poppins_400Regular',
  },
  text: {
    fontSize: 14,
    color: Colors.light.hereworksPrimaryGrey,
    fontFamily: 'Roboto_400Regular',
    justifyContent: 'center',
    paddingHorizontal: 10,
    flex: 1,
  },
  selectedText: {
    fontSize: 14,
    color: '#fff',
    fontFamily: 'Roboto_400Regular',
    paddingHorizontal: 10,
    flex: 1,
  },
  betaText: {
    fontSize: 11,
    lineHeight: 16,
    color: Colors.light.hereworksYellow500,
    fontFamily: 'Roboto_500Medium',
    marginRight: 16,
    paddingVertical: 1,
    paddingHorizontal: 6,
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksYellow300,
    borderRadius: 4,
    position: 'absolute',
    right: -10,
    top: 5,
  },
  indent: {
    borderLeftWidth: 1,
    height: 40,
    alignSelf: 'center',
    borderColor: Colors.light.hereworksBlue200,
    marginLeft: 40,
  },
});
